import _classCallCheck from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
/**
 * Error thrown on an axios response if the response can be mapped to a safe error.
 * A SafeApiError has a `message` which is mapped from a `help` message on the raw response
 * and is safe to show the user.
 */
var SafeApiError = /*#__PURE__*/function (_Error) {
  _inherits(SafeApiError, _Error);
  var _super = _createSuper(SafeApiError);
  function SafeApiError(help, errorMessage, details, errorCode, response, axiosError) {
    var _this;
    _classCallCheck(this, SafeApiError);
    _this = _super.call(this, help);
    _this.name = ''; // sets to empty string to avoid is being prepended to the message
    _this.type = 'SafeApiError';
    _this.errorMessage = errorMessage;
    _this.details = details;
    _this.errorCode = errorCode;
    _this.response = response; // set the raw response for backwards compatibility with an AxiosError
    _this.axiosError = axiosError;
    return _this;
  }
  _createClass(SafeApiError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        type: this.type,
        message: this.message,
        errorMessage: this.errorMessage,
        details: this.details,
        errorCode: this.errorCode
      };
    }
  }]);
  return SafeApiError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { SafeApiError };